/// <amd-module name="Wiki/PageComments/WikiPageCommentsHelper" />
import { ICommentArtifactInfo } from "Comments/Common/Contracts";
import { WikiArtifact } from "Wiki/PageComments/Contracts";

export const WikiPageArtifactKind = "C38A95A3-8516-40C1-BC31-247A5008586B";
export const ForwardSlash = "/";

export function convertArtifactInfoToWikiCommentArtifact(artifactInfo: ICommentArtifactInfo): WikiArtifact {
    const artifactComponents = artifactInfo.artifactId.split(ForwardSlash);
    if (
        artifactComponents.length < 3 ||
        isEmptyOrUndefined(artifactComponents[0]) ||
        isEmptyOrUndefined(artifactComponents[1]) ||
        isEmptyOrUndefined(artifactComponents[2])
    ) {
        throw new Error("Invalid Artifact Id: " + artifactInfo.artifactId);
    }

    const projectId = artifactComponents[0];
    const wikiId = artifactComponents[1];
    const pageId = Number(artifactComponents[2]);
    return { projectId, wikiId, pageId };
}

export function buildCommentArtifactInfo(wikiArtifact: WikiArtifact): ICommentArtifactInfo {
    return {
        artifactId: wikiArtifact.projectId + ForwardSlash + wikiArtifact.wikiId + ForwardSlash + wikiArtifact.pageId,
        artifactKind: WikiPageArtifactKind,
        projectId: wikiArtifact.projectId
    };
}

function isEmptyOrUndefined(text: string | undefined): boolean {
    return !text || text.trim() == "";
}
